import { authorize, patchRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from './mapData';

export async function updateLightningDeviceAPI(device) {
  const url = `${AWS_API_URL}/lighting/device`;

  return patchRequest(url, mapDataForBackend(device), await authorize());
}
